import { forwardRef, VisuallyHidden as _VisuallyHidden } from "@chakra-ui/react";

export const VisuallyHidden = forwardRef((props, ref) => <_VisuallyHidden ref={ref} {...props} />);
